<template>
  <st-modal
    class="st-reset-password-success-modal"
    @esc-close="close"
    v-if="open"
  >
    <template v-slot:header>
      <div class="st-reset-password-success__header st-modal-header">
        <h3>Återställ lösenord</h3>
        <span class="st-reset-password-success__header__desc">
          Nya inloggningsuppgifter har skickats till adressen du angav.
        </span>
      </div>
    </template>

    <template v-slot:body>
      <div class="st-reset-password-success__body st-modal-body">
        Om mejladressen finns i systemet så kommer ett mejl inom kort med
        instruktioner om hur du gör för att återställa lösenordet.
      </div>
    </template>

    <template v-slot:footer>
      <div class="st-reset-password-success__footer">
        <div class="st-reset-password-success__footer__actions">
          <st-button
            :id="'submit'"
            @click="close"
            tabindex="0"
            @keydown.tab.native="onTab"
            >Tillbaka till start</st-button
          >
        </div>
      </div>
    </template>
  </st-modal>
</template>

<script>
import { StButton, StModal } from "skanetrafiken/dist/legacy";
import { tabToFirstElement } from "@/modules/login-form/helpers/modalTabHelper";
export default {
  name: "st-reset-password-success-modal",
  props: {
    close: {
      type: Function,
    },
    open: {
      type: Boolean,
    },
  },
  components: {
    StButton,
    StModal,
  },
  methods: {
    onTab(e) {
      tabToFirstElement(e, "submit");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~skanetrafiken/dist/scss/main.scss";

.st-reset-password-success {
  font-family: $source-sans-pro;
  color: $dark-grey;
  font-size: rem-calc(16);
  &__header {
    &__desc {
      display: flex;
      margin-top: rem-calc(20);
      font-family: $source-sans-pro;
      font-weight: $semi-bold;
      color: $dark-grey;
      line-height: rem-calc(20);
    }
  }
  &__body {
    font-family: $source-sans-pro;
    color: $dark-grey;
    line-height: rem-calc(20);
  }
  &__footer {
    margin-top: rem-calc(20);
    &__actions {
      display: flex;
      flex: 1;
      & > .st-button {
        &:first-child {
          margin-right: rem-calc(8);
        }
        flex: 1;
      }
    }
  }
}
</style>
